import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SubmissionListByFilterPayload,
  SubmissionListByFilterResponse,
  SubmissionStatusResponse,
  UnderwriterSubmissionPayload,
  UnderwriterSubmissionResponse
} from '../../../core/services/data-aggregation.service';
import { SubmissionTableLabRow } from './submission-table-lab.models';

export type SubmissionTableLabLiveStatus = {
  title: string;
  detail: string;
} | null;

export type SubmissionTableLabLoadPayload = UnderwriterSubmissionPayload;
export type SubmissionTableLabLoadResponse = UnderwriterSubmissionResponse;
export type SubmissionTableLabListResponse = SubmissionListByFilterResponse;
export type SubmissionTableLabStatusResponse = SubmissionStatusResponse;

export interface SubmissionTableLabAdapter {
  readonly transientSocketStatus: Signal<SubmissionTableLabLiveStatus>;

  getUserId(): number | null;
  getCurrentUserUnderwriterFilter(): string;

  loadSubmissions(payload: SubmissionTableLabLoadPayload): Observable<SubmissionTableLabLoadResponse>;
  listSubmissionsByFilter(payload: SubmissionListByFilterPayload): Observable<SubmissionTableLabListResponse>;
  getSubmissionStatus(submissionId: string, quoteId: string): Observable<SubmissionTableLabStatusResponse>;

  getRowActionStatus(row: SubmissionTableLabRow): SubmissionTableLabRow['actionStatus'];
  isProcessingSubmission(submissionId: string): boolean;
  isOpeningSubmission(submissionId: string): boolean;
  getProcessingProgress(submissionId: string): number;
  openProcessedSubmission(row: SubmissionTableLabRow): void;
  startSubmissionProcessing(row: SubmissionTableLabRow): void;
}

export const SUBMISSION_TABLE_LAB_ADAPTER =
  new InjectionToken<SubmissionTableLabAdapter>('SUBMISSION_TABLE_LAB_ADAPTER');
